export default "__VITE_ASSET__07779632__"